export default [
    {
        textColor: 'white',
        textSize: 11,
        textDecoration: 'none',
        textLineHeight: 53,
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontFamily: 'Arial,sans-serif',
        backgroundPosition: '0 0',
        url: require('@/assets/maps/markerclusterer/m1.png'),
        height: 53,
        width: 53,
    },
    {
        textColor: 'white',
        textSize: 11,
        textDecoration: 'none',
        textLineHeight: 56,
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontFamily: 'Arial,sans-serif',
        backgroundPosition: '0 0',
        url: require('@/assets/maps/markerclusterer/m2.png'),
        height: 56,
        width: 56,
    },
    {
        textColor: 'white',
        textSize: 11,
        textDecoration: 'none',
        textLineHeight: 66,
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontFamily: 'Arial,sans-serif',
        backgroundPosition: '0 0',
        url: require('@/assets/maps/markerclusterer/m3.png'),
        height: 66,
        width: 66,
    },
    {
        textColor: 'white',
        textSize: 11,
        textDecoration: 'none',
        textLineHeight: 78,
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontFamily: 'Arial,sans-serif',
        backgroundPosition: '0 0',
        url: require('@/assets/maps/markerclusterer/m4.png'),
        height: 78,
        width: 78,
    },
    {
        textColor: 'white',
        textSize: 11,
        textDecoration: 'none',
        textLineHeight: 90,
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontFamily: 'Arial,sans-serif',
        backgroundPosition: '0 0',
        url: require('@/assets/maps/markerclusterer/m5.png'),
        height: 90,
        width: 90,
    },
];
